// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2o-1";
export var rateTableServiceLevelDropdown = "_2o-3";
export var rateTableTypeDropdown = "_2o-0";
export var rateTableValueModeDropdown = "_2o-2";